import { useWhenProviderReady } from '@openfeature/react-sdk';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { useSampleSet } from '../../../../../../contexts/SampleSetContext';
import {
  FEATURE_FLAGS,
  useFeatureFlag,
} from '../../../../../../lib/featureFlags';
import SampleSetChat from '../../../../../../pages/experiments/chat/SampleSetChat';

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/chat'
)({
  staticData: { ddViewName: 'experiments-chat-tab' },
  component: ChatRouteComponent,
});

function ChatRouteComponent() {
  // Gate in the component (not beforeLoad) so it reacts to the OpenFeature
  // provider becoming ready. On a cold load the provider isn't ready yet, so a
  // flag read returns its default (false) — gating in beforeLoad would 404 a
  // legitimately-enabled tab. useWhenProviderReady waits for the real provider.
  const flagsReady = useWhenProviderReady();
  const chatEnabled = useFeatureFlag(FEATURE_FLAGS.chatTab);
  const { sampleSet } = useSampleSet();

  if (!flagsReady) {
    return null;
  }

  // With the flag off the Chat tab doesn't exist for this user.
  if (!chatEnabled) {
    throw notFound();
  }

  if (!sampleSet) {
    return null;
  }

  return <SampleSetChat sampleSetId={sampleSet.id} />;
}
